import { render, staticRenderFns } from "./entry-list2.vue?vue&type=template&id=47b73649&"
import script from "./entry-list2.vue?vue&type=script&lang=js&"
export * from "./entry-list2.vue?vue&type=script&lang=js&"
import style0 from "./entry-list2.vue?vue&type=style&index=0&id=47b73649&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports